<template>
  <div class="field-wrapper field-wrapper--select"
       :class="[field.cssClass, {'visually-hidden': field.visibility === 'hidden'}, 'field-wrapper--' + field.size]">
    <div class="field-group field-group--select"
         :class="[{'field-group--is-error': isError}]">
      <label
        class="label label--select"
        :for="'input_' + formId + '_' + field.id"
        :class="[{'visually-hidden': field.labelPlacement === 'hidden_label'}]"
      >
        {{ field.label }}<sup v-if="field.isRequired">*</sup>
      </label>

      <template v-if="isMobileAndTouch">
        <select
          :id="'input_' + formId + '_' + field.id"
          class="select select--big"
          :class="[{'select--locations': field.adminLabel === 'Standort'}]"
          :name="'input_' + field.id"
          v-model="selectedValue"
          :required="field.isRequired"
        >
          <option v-for="choice in filteredChoices" :value="choice.value || choice.slug">
            {{ choice.text || choice.name }}
          </option>
        </select>
      </template>
      <template v-else>
        <template v-if="field.adminLabel === 'Standort'">
          <multiselect v-if="filteredChoices && filteredChoices.length > 0"
                       v-model="selectedObject"
                       :id="'input_' + formId + '_' + field.id"
                       :options="results"
                       class="multiselect--locations"
                       :custom-label="completeAddress"
                       :placeholder="$store.state.lexicon.location_or_postal_code"
                       :internal-search="false"
                       :loading="isLoading"
                       @search-change="asyncFind"
                       track-by="value">
            <template slot="option" slot-scope="props">
              <span v-if="props.option && props.option.description && props.option.description.address_postal_code"
                    class="multiselect__option-text">{{ `${props.option.description.address_postal_code ? 'CH-' + props.option.description.address_postal_code : ''} ${props.option.description.address_city}${props.option.description.address_street ? ', ' + props.option.description.address_street : ''}` }}</span>
              <span
                v-else
                class="multiselect__option-text multiselect__option-text--no-icon">-</span>
            </template>
            <span slot="noResult">{{ lexicon.location_no_result }}</span>
          </multiselect>
        </template>
        <template v-else>
          <multiselect v-if="filteredChoices && filteredChoices.length > 0"
                       v-model="selectedObject"
                       :id="'input_' + formId + '_' + field.id"
                       :options="results"
                       class="multiselect--regular"
                       label="text"
                       placeholder="-"
                       track-by="value">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </template>
      </template>

    </div>

    <slot name="description"></slot>
    <slot name="error"></slot>
  </div>
</template>

<script>
import isTouchDevice from "is-touch-device";
import isMobile from "ismobilejs";
import Multiselect from "vue-multiselect"
import store from '../store';
import VFieldMixins from './VFieldMixins.vue';
import VIcon from '../VIcon/vue-icon.vue';
import slugify from 'slugify';
import staticVars from '../static-vars/static-vars';

const templateUrl = staticVars.templateUrl
export default {
  store,
  name: "VFieldSelect",
  mixins: [VFieldMixins],
  components: {Multiselect},
  data() {
    return {
      isLoading: false,
      selectedValue: "-",
      results: [],
      keywords: [],
      selectedObject: {
        isSelectable: true,
        isSelected: false,
        text: "-",
        value: "-"
      },
      isChoiceForceSet: false
    }
  },

  mounted() {

    if (this.field.adminLabel === "Standort") {

      fetch(`${templateUrl}/assets/data/garages.json`)
        .then((response) => {

          return response.json()
        }).then((json) => {
        //console.log('garages ', json)
        this.keywords = json
      }).catch((ex) => {
        console.log('parsing failed', ex)
      })

      store.commit("UPDATE_FORM_LOCATIONS_CHOICES", this.choices)
      //console.log(this.field.choices);
    }

    const preSelectedChoice = this.field.choices.find(item => item.isSelected)
    if (preSelectedChoice) {
      this.selectedObject = preSelectedChoice
    }

    this.results = this.choices;
  },

  computed: {

    isMobileAndTouch() {
      return isTouchDevice() && isMobile(navigator.userAgent).any
    },

    // Standort choices need address data; drop incomplete ones (keep the "-" empty option)
    choices() {
      if (this.field.adminLabel !== "Standort") {
        return this.field.choices
      }

      return this.field.choices.filter(item => {
        return item.value === "-" || (item.description && item.description.address_city)
      })
    },

    filteredChoices() {
      let temp = [];
      temp = this.choices;

      if (this.field.adminLabel === "Modell" && store.state.user_form_data_with_label.input_Marke !== "-") {
        temp = this.choices.filter(item => {
          return item.description && item.description.brand === store.state.user_form_data_with_label.input_Marke || item.value == "-"
        })

        if (temp.findIndex(item => item.value === this.selectedValue) === -1) {
          this.selectedValue = "-"
          this.selectedObject = this.choices[0]
        }

        store.commit("UPDATE_FORM_MODELS_CHOICES", temp)


      } else if (
        this.field.adminLabel === "Standort" &&
        this.$store.state.user_form_data_with_label.input_Modell !== "-")
      {
        const currentModel = this.$store.state.models.find(item => item.value === this.$store.state.user_form_data_with_label.input_Modell)
        const modelLocations = currentModel?.description?.locations || []

        temp = this.$store.state.locations.filter(item => {
          return modelLocations.find(location => location.slug.replace('-it', '') === item.value)
        })


        temp = [...[this.choices[0]], ...temp];

        if (temp.findIndex(item => item.value === this.selectedValue) === -1) {
          this.selectedValue = '-'
          if (this.choices) {
            this.selectedObject = this.choices[0]
          } else {
            this.selectedObject = {
              isSelectable: true,
              isSelected: false,
              text: "-",
              value: "-"
            }
          }
        }
      }
      else if (
        this.field.adminLabel === "Standort" &&
        this.$store.state.user_form_data_with_label.input_Marke !== "-"
      ) {

        temp = this.$store.state.locations.filter(item => this.$store.state.models.some(modelItem => {
          return (modelItem.description?.locations || []).find(location => location.slug.replace('-it', '') === item.value)
        }))

        temp = [...[this.choices[0]], ...temp];

        if (temp.findIndex(item => item.value === this.selectedValue) === -1) {
          this.selectedValue = "-"
          if (this.choices) {
            this.selectedObject = this.choices[0]
          } else {
            this.selectedObject = {
              isSelectable: true,
              isSelected: false,
              text: "-",
              value: "-"
            }
          }

        }
      } else if (this.field.adminLabel === "Modell") {
        store.commit('UPDATE_FORM_MODELS_CHOICES', temp)
      } else {
        temp = this.choices;
      }

      if (!this.isChoiceForceSet && this.field.adminLabel === "Modell" && localStorage.getItem("selectedVehicle")) {
        this.selectedObject = temp.find(item => {
          return item.value === localStorage.getItem("selectedVehicle");
        })

        this.isChoiceForceSet = true
      }

      if (this.field.adminLabel === "Marke" && localStorage.getItem("selectedBrand")) {
        this.selectedObject = temp.find(item => {
          return item.text === localStorage.getItem("selectedBrand");
        })
      }

      return temp;
    }
  },

  methods: {
    toSLug(text) {
      return slugify(text, {
        lower: true,
        strict: true,
      })
    },

    completeAddress(item) {
      if (item.hasOwnProperty('description') && item.description.address_postal_code) {
        return `${item.description.address_postal_code ? 'CH-' + item.description.address_postal_code : ''} ${item.description.address_city}${item.description.address_street ? ', ' + item.description.address_street : ''}`
      } else {
        return '-'
      }
    },

    asyncFind(query) {
      this.isLoading = true
      const lowerCaseQuery = query.toLowerCase()

      const resultFromGarage = this.keywords.find(item => {
        return item.plz.toString().startsWith(query) ||
          (this.toSLug(item.ort)).indexOf(this.toSLug(lowerCaseQuery)) > -1
      })

      const temp = this.filteredChoices.filter(item => {
        const description = item.description
        if (!description || !description.address_city) {
          return false
        }

        const city = String(description.address_city).toLowerCase()
        const postalCode = String(description.address_postal_code || '').toLowerCase()
        const street = String(description.address_street || '').toLowerCase()

        return resultFromGarage?.standort === description.address_city ||
          city.indexOf(lowerCaseQuery) > -1 ||
          postalCode.indexOf(lowerCaseQuery) > -1 ||
          street.indexOf(lowerCaseQuery) > -1
      })

      if (!query) {
        this.results = this.filteredChoices;
      }

      if (temp.length) {
        this.results = temp
      } else {
        this.results = []
      }

      this.isLoading = false
    },
  },

  props: {
    formId: Number,
    field: Object,
    fieldKey: Number,
    isError: String,
    lexicon: Object,
  },
  watch: {
    selectedObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedValue = newValue ? newValue.value : '-'
      }
    },

    filteredChoices: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.results = newValue
      }
    },

    selectedValue: {
      immediate: true,
      deep: false,
      handler(newValue) {
        store.commit(
          'UPDATE_USER_FORM_DATA_WITH_LABEL',
          {'key': this.field.adminLabel, 'value': newValue })

        store.commit(
          'UPDATE_USER_FORM_DATA',
          {'key': this.field.id, 'value': newValue === '-' ? '' : newValue})
      }
    }
  }
}
</script>
